/**
 * 更新 .content 結構的顯示頁面
 */
export const updateContentDisplay = (contentRef, pageIndex) => {
  if (!contentRef.current) return;
  
  const contentElements = contentRef.current.querySelectorAll('div.content');
  
  // 處理 .content 結構
  contentElements.forEach((contentEl, index) => {
    if (index === pageIndex) {
      contentEl.style.visibility = 'visible';
      contentEl.style.position = 'relative';
    } else {
      contentEl.style.visibility = 'hidden';
      contentEl.style.position = 'absolute';
    }
  });
  
  // 處理 .imgSize 和 .img 內的內容，固定在第一頁顯示
  const allImgSizeElements = contentRef.current.querySelectorAll('.imgSize');
  if (allImgSizeElements.length > 0) {
    const firstImgSize = allImgSizeElements[0];
    const firstImgSizeImgs = firstImgSize.querySelectorAll('img');

    firstImgSizeImgs.forEach(img => {
      const shouldShow = pageIndex === 0;
      img.style.visibility = shouldShow ? 'visible' : 'hidden';
      img.style.position = shouldShow ? 'relative' : 'absolute';
    });
  }
  
  // 處理 .img div 內的內容（如果有的話）
  const allImgElements = contentRef.current.querySelectorAll('img');
  allImgElements.forEach(img => {
    const isInImgDiv = img.closest('.img') !== null;
    const isInFirstImgSize = img.closest('.imgSize') === allImgSizeElements[0];
    
    if (isInImgDiv && !isInFirstImgSize) {
      const shouldShow = pageIndex === 0;
      img.style.visibility = shouldShow ? 'visible' : 'hidden';
      img.style.position = shouldShow ? 'relative' : 'absolute';
    }
  });
};

